import { gql } from '@apollo/client';


export const CREATE_PUPIL = gql`
mutation CreateStudent($schoolID: Int, $input: RegisterStudent) {
  createStudent(schoolID:$schoolID, input: $input) 
}
`;

export const CREATE_BULK_PUPIL = gql`
mutation CreateBulkStudent($schoolID: Int, $input: [RegisterStudent]) {
  createBulkStudent(schoolID:$schoolID, input: $input) 
}
`;



export const DELETE_PUPIL = gql`
mutation DeleteStudent($schoolID: Int, $studentID: Int) {
  deleteStudent(schoolID:$schoolID, studentID: $studentID)
}
`;


export const UPDATE_PUPIL = gql`
mutation UpdateStudent($schoolID: Int, $studentID: Int, $input: UpdateStudent) {
  updateStudent(schoolID:$schoolID, studentID: $studentID, input: $input)
}
`;



export const GET_STUDENTS = gql`
query GetStudentsBySchool($schoolID: Int) {
  getStudentsBySchool(schoolID: $schoolID) {
    id
    roomID
    room {
      campusID
      id
      name
      real_class
    }
    parents {
      id
      firstname
      lastname
      email
      phone
      gender
      photo
    }
    firstname
    middlename
    lastname
    dateOfBirth
    gender
    status
    photo
    checkedIn
    balance
    studentCode
    bill
    details
    parentReplied
    report_card
    report_card_html
    result_raw
    result_raw_first
    result_raw_second
    result_raw_third
    has_face_vector
  }
}
`;




export const GET_INACTIVE_STUDENTS = gql`
query GetInactiveStudentsBySchool($schoolID: Int) {
  getInactiveStudentsBySchool(schoolID: $schoolID) {
    id
    roomID
    room {
      campusID
      id
      name
      real_class
    }
    parents {
      id
      firstname
      lastname
      email
      phone
      gender
      photo
    }
    firstname
    middlename
    lastname
    dateOfBirth
    gender
    status
    photo
    checkedIn
    balance
    bill
    studentCode
    details
    parentReplied
    updated_at
    created_at
  }
}
`;

export const RESET_ALL_STUDENT_CODES = gql`
mutation ResetAllStudentCodes($schoolID: Int) {
  resetAllStudentCodes(schoolID: $schoolID)
}
`;

export const RESET_SINGLE_STUDENT_CODE = gql`
mutation ResetSingleStudentCode($schoolID: Int, $studentID: Int) {
  resetSingleStudentCode(schoolID: $schoolID, studentID: $studentID)
}
`;


export const CREATE_PROSPECTIVE_STUDENTS = gql`
mutation Mutation($schoolID: Int, $name: String, $human_type: String, $classroom: String, $parent_name: String, $phone: String, $email: String, $date: String) {
  createProspectiveStudent(schoolID: $schoolID, name: $name, human_type: $human_type, classroom: $classroom, parent_name: $parent_name, phone: $phone, email: $email, date: $date)
}
`;


export const DELETE_PROSPECTIVE_STUDENTS = gql`
mutation DeleteProspectiveStudent($schoolID: Int, $ID: Int) {
  deleteProspectiveStudent(schoolID: $schoolID, ID: $ID)
}
`;

export const MARK_SMS_AS_SENT = gql`
mutation MarkSMSAsSent($schoolID: Int, $ID: Int) {
  markSMSAsSent(schoolID: $schoolID, ID: $ID)
}
`;

export const GET_PROSPECTIVE_STUDENTS_SMS = gql`
query Query($schoolID: Int, $ID: Int) {
  getProspectiveStudentSMS(schoolID: $schoolID, ID: $ID)
}
`;

export const GET_PROSPECTIVE_STUDENTS = gql`
query Query($schoolID: Int, $offset: Int) {
  getProspectiveStudents(schoolID: $schoolID, offset: $offset)
}
`;
export const GET_PROSPECTIVE_SMS_TODAY = gql`
query Query($schoolID: Int) {
  getProspectiveSchoolSMS(schoolID: $schoolID)
}
`;

export const PROMOTE_STUDENTS = gql`
mutation Promote($schoolID: Int, $ids: [Int!], $sourceRoomID: Int, $destinationRoomID: Int) {
  promoteStudents(schoolID: $schoolID, ids: $ids, sourceRoomID: $sourceRoomID, destinationRoomID: $destinationRoomID)
}
`;